<template>
  <div>
    <modal 
      name="info-operacion" 
      :width="1000" 
      :height="600" 
      :clickToClose="false" 
      :scrollable="true"
      :class="{'front-modal': isFrontModal}"
    >
      <div class="modal-content modalContent">
        <span class="closebtn" @click="closeModal">&times;</span>
        
        <div class="text-center mt-4">
          <h3 class="with-lines">Información Status Archivos</h3>
        </div>
        
        <div class="row p-4 scrollable-content">
          <div class="table-responsive">
            <table class="table text-center">
              <thead>
                <tr>
                  <th scope="col">Requisito</th>
                  <th scope="col">Visor</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(result, i) in listDocs" :key="i">
                  <th style="width: 240px;" class="text-center" scope="row">
                    <p class="mt-2" style="line-height:0px">{{result.tipoArchivo}}</p>
                    {{result.NombreArchivo}}
                  </th>
                  
                  <td style="width: 120px;" class="text-center">
                    <button 
                      @click="mostrarPDF(result.archivoB64, result.NombreArchivo)" 
                      type="button" 
                      class="btn btn-blue col-6 mt-3 btn-sm"
                    >
                      <i class="fas fa-eye mr-1"></i>
                      Ver
                    </button>
                  </td>
                  
                  <td class="text-center" style="width: 190px;">
                    <p v-if="result.IdArchivo != '140'" class="mt-3">
                      {{result.EstatusArchivo == 1 ? 'Correcto' : 'Solicitar Nuevamente'}}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: 'InfoOperacionModal',
  props: {
    listDocs: Array,
    mostrarPDF: Function,
    isFrontModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide('info-operacion');
    }
  }
};
</script>

<style>
.scrollable-content {
  max-height: 500px;
  overflow-y: auto;
}

.file-select {
  position: relative;
  display: inline-block;
  cursor: pointer !important;
}

.file-select::before {
  background-color: #ffffff;
  color: rgba(4, 12, 34, 0.664);
  display: flex;
  justify-content: center;
  align-items: center;
  content: 'Seleccionar';
  position: absolute;
  left: 5%;
  top: 20%;
  cursor: pointer !important;
}

.file-select input[type="file"] {
  opacity: 0 !important;
  width: 200px !important;
  height: 32px !important;
  display: inline-block !important;
  cursor: pointer !important;
}

.btn-blue {
  border-radius: 10px;
  background-image: linear-gradient(to right, #085da8, #003c71);
  border: none;
  color: white;
}

.vm--modal {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background-color: white;
  border-radius: 30px !important;
}

.modalContent {
  padding: 15px;
  background-color: white;
  color: black;
  border-radius: 15px;
  position: relative;
  text-align: center;
}

.closebtn {
  position: absolute;
  top: 10px;
  right: 15px;
  color: #003c71;
  font-weight: bold;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:focus {
  outline: 2px solid #003c71;
  outline-offset: 2px;
}

.closebtn:hover {
  color: #003c718c;
}

.iframe-content {
  width: 100%;
  height: calc(100% - 50px);
  border: none;
  border-radius: 0 0 15px 15px;
}

.modal-header {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #003c71;
}

.modal-body {
  padding: 20px;
}
</style>
